import Joi from 'joi';
import { PackageDetail } from '../interfaces';

export const CreateAccountPayloadSchema = Joi.object({
  company: Joi.string(),
  confirmPassword: Joi.string(),
  country: Joi.string(),
  firstName: Joi.string(),
  jobTitle: Joi.string(),
  lastName: Joi.string(),
  password: Joi.string(),
  recaptchaToken: Joi.string(),
  companySize: Joi.string().allow(null),
});

export const CreateAccountSchema = Joi.object({
  access_token: Joi.string(),
  subscriptionId: Joi.string(),
  subscriptionType: Joi.string(),
  url: Joi.string(),
  loginUrl: Joi.string(),
  emailHash: Joi.string(),
  avatarWizard: Joi.boolean(),
  id: Joi.string(),
  partner: Joi.object({
    id: Joi.string(),
  }),
});

export const PackageDetailSchema = Joi.object({
  department_list: Joi.array().items(Joi.string()),
  company_size_list: Joi.array().items(Joi.string()),
  createAccountMediaUrl: Joi.string(),
});
